import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//
import { Card, Row } from "react-bootstrap";

//
import BestInWeeksItem from "./BestInWeeksItem";
import NothingToShow from "../general/NothingToShow";
import BoxLoading from "../general/BoxLoading";

//
import { getMostChangedVolume } from "../../redux/features/coins/actions";

//
import SwiperCore, { Navigation, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
SwiperCore.use([Navigation, Scrollbar, A11y]);

function BestInWeeks(props) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  /**
   * Get Most Changed Volume
   */
  const get_most_changed_valume = async () => {
    // start loading
    setLoading(true);

    // request
    await getMostChangedVolume().then((res) => {
      if (res) {
        setItems(res);
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_most_changed_valume();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {items.length ? (
        <Row className="best-in-weeks">
          {items.map((item) => (
            <BestInWeeksItem item={item} />
          ))}
        </Row>
      ) : (
        <Card className="gutter-b">
          <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
          {loading && <BoxLoading />}
        </Card>
      )}
    </>
  );
}

BestInWeeks.propTypes = {};

export default BestInWeeks;
